import React from 'react';
import I18N from '@leverege/i18n';
import { Flex, Text, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { LoadingView } from '@leverege/molten/views';
import P from '@leverege/promise';
import RecovrSales from '../../util/RecovrSales';
import C from '../../views/salesFlow/Constants';
import DefaultDialog from '../../components/DefaultDialog';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.markAsLost.markAsLostDialog');
export default class MarkAsLostDialog extends React.Component {
  onOkay = async () => {
    const {
      type,
      actions,
      onClose,
      devices
    } = this.props;
    let results = [];
    const closeLoading = LoadingView.showDialog(t('loading'));
    try {
      if (type === 'vehicle') {
        // You've gotten here through the vehicles group screen.
        // Vehicle actions and vehicle device have been provided already
        results = await P.mapLimit(devices, async vehicle => {
          try {
            const result = await RecovrSales.sell({
              actions,
              onChange: null,
              onClose,
              newLocator: null,
              vehicle,
              hasCustomer: false,
              vehicleLeftLot: true,
              saleType: C.SALE_TYPES.VEHICLE_ONLY,
              toast: false,
              goToSales: true
            });
            return result;
          } catch (err) {
            console.error('Could not Mark As Lost', err);
            return new Error(err.message);
          }
        }, {
          limit: 5
        });

        // You've gotten here through the locators group screen
      } else {
        await P.mapLimit(devices, async locator => {
          const vehicleId = locator.data?.data?.vehicle?.id;
          if (vehicleId) {
            // the locator is paired with a vehicle. Get the
            // vehicle actions and locator so that you can call the
            // RecoverSales.sell function.
            try {
              const vehicleActions = actions.parent().parent().child('vehicles').itemActions(vehicleId);
              const vehicle = {
                data: await GlobalState.dispatch(vehicleActions.get()),
                id: vehicleId
              };
              const res = await RecovrSales.sell({
                actions: vehicleActions,
                onChange: null,
                onClose,
                newLocator: null,
                vehicle,
                hasCustomer: false,
                vehicleLeftLot: true,
                saleType: C.SALE_TYPES.VEHICLE_ONLY,
                toast: false,
                goToSales: true
              });
              results.push(res);
            } catch (err) {
              console.error('Could not Mark As Lost', err);
              results.push(new Error(err.message));
            }
          } else {
            // locator is not paired to a vehicle and must go through the custom markAsLost endpoint to not sell vehicle
            try {
              const res = await RecovrSales.markAsLost({
                actions,
                locator
              });
              results.push(res);
            } catch (err) {
              console.error('Could not Mark As Lost', err);
              results.push(new Error({
                message: err.message
              }));
            }
          }
        });
      }

      // tally up results for collective toast
      const successes = [];
      const failures = [];
      results.forEach((result, idx) => {
        if (result instanceof Error || !result) {
          failures.push(result);
        } else {
          successes.push(devices[idx]);
        }
      });
      const successesLength = successes.length;
      const failuresLength = failures.length;
      const total = successes.length + failures.length;
      if (failuresLength > 0) {
        let errorMsg = `Error: Could not Mark ${failuresLength} devices as Lost`;
        if (failuresLength === 1) {
          errorMsg = `Error: ${failures[0]?.message}`;
        }
        Toast.error(errorMsg);
      }
      if (successesLength > 0) {
        let errorMsg = '';
        if (failuresLength > 0) {
          errorMsg = `Errors: ${failuresLength}`;
        }
        let successMsg = `Successfully marked ${successesLength} out of ${total} devices as lost. ${errorMsg}`;
        if (successesLength === 1 && failuresLength === 0) {
          successMsg = 'Successfully Marked As Lost';
        }
        Toast.success(successMsg);
      }
    } catch (err) {
      console.log(`Could not mark as Lost: ${err}`);
      Toast.error(`Could not mark as Lost: ${err.message}`);
    }
    closeLoading();
    onClose();
  };
  onCancel = () => {
    const {
      onClose
    } = this.props;
    onClose();
  };
  render() {
    const {
      show,
      onClose,
      devices,
      vehicleLocator,
      type
    } = this.props;
    const isBulk = devices.length > 1;

    // display different messages based on whether it is bulk or singular selection
    // if the selected device is a vehicle and it is paired, show vehicle dialog with vehicle note
    // if the selected device is a locator and it is paired, show locator dialog with locator note
    // if the selected device is a locator that is not paired, then show locator dialog without locator note
    // if bulk selection, show bulk vehicle message if type vehicle, otherwise show locator specific messages
    let vin, serialNumber, isPaired, messageText, noteMessage, okayButton, vehicleSecondaryMessage, bulkNote;
    if (isBulk) {
      if (type === 'vehicle') {
        messageText = t('bulkVehicleMessage');
        noteMessage = t('vehicleNote');
        okayButton = t('vehicleOkay');
        vehicleSecondaryMessage = t('vehicleMessageGeneral');
      } else {
        messageText = t('bulkLocatorMessage');
        noteMessage = t('bulkLocatorNote');
        okayButton = t('vehicleOkay');
      }
    } else {
      isPaired = devices[0]?.data?.data?.locator?.id || devices[0]?.data?.data?.vehicle?.id;
      if (isPaired) {
        vin = devices[0].data?.data?.vin || devices[0].data?.data?.pairMetadata?.vehicleVin;
      }
      if (vehicleLocator) {
        serialNumber = vehicleLocator.data?.serialNumber;
      }
      messageText = serialNumber ? t('vehicleMessage') : t('locatorMessage');
      noteMessage = serialNumber ? t('vehicleNote') : t('locatorNote', {
        vin
      });
      okayButton = isPaired ? serialNumber ? t('vehicleOkay') : t('locatorOkay') : t('unpairedOkay');
      vehicleSecondaryMessage = isPaired ? t('vehicleMessageWithLocator', {
        serialNumber
      }) : null;
    }
    return /*#__PURE__*/_jsx(DefaultDialog, {
      show: show,
      onClose: onClose,
      titleIcon: tIcon('headerIcon'),
      title: t('title'),
      submitText: okayButton,
      onSubmit: this.onOkay,
      onCancel: this.onCancel,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "body",
          children: messageText
        }), type === 'vehicle' && /*#__PURE__*/_jsx(Text, {
          variant: "body",
          children: vehicleSecondaryMessage
        }), (isPaired || isBulk) && /*#__PURE__*/_jsxs(Text, {
          variant: "body",
          children: [/*#__PURE__*/_jsx("strong", {
            children: t('note')
          }), noteMessage]
        })]
      })
    });
  }
}